"use strict";
exports.__esModule = true;
exports.paramsSchema = exports.Method = exports.Endpoint = void 0;
exports.Endpoint = 'chat/get-chat-image-src';
exports.Method = 'GET';
exports.paramsSchema = { "type": "object", "properties": { "messageUUID": { "type": "string" } }, "required": ["messageUUID"], "$schema": "http://json-schema.org/draft-07/schema#" };
